import { FormSectionHandler } from '../entity.handler';
import { CompanyGroupResponse, IdName, CompanyGroupUpdateRequest } from '@key-telematics/fleet-api-client';
import { AdminEditorService } from '../../admin.service';
import { FormBuilderField } from 'app/shared/components/form-builder';
import { TextField, EntityUtils, ComboField, IdNameComboValueHandlers } from '../utils';
import { ICONS } from '../icons';
import { AssetGroupingService } from 'app/services';

interface EditorValues {
    name?: string;
    parent?: IdName;
}


export class CompanyGroupDetailsSectionHandler implements FormSectionHandler<CompanyGroupResponse, EditorValues> {

    type = 'form';
    icon = ICONS.companygroup;
    bulk = true;

    title = this.translate('TITLE');
    description = this.translate('DESC');

    constructor(
        public admin: AdminEditorService,
        public ownerId: string
    ) {
    }

    private properties = ['name', 'parent'];

    translate(key: string, values?: Object): string {
        return this.admin.translate(`EDITORS.COMPANYGROUP.DETAILS.${key}`, values);
    }

    applyUpdate(entity: CompanyGroupResponse, payload: CompanyGroupUpdateRequest): Promise<CompanyGroupResponse> {
        return this.admin.applyUpdate(api => api.accounts.updateCompanyGroup(entity.id, payload), { _navigation: 'companygroup' });
    }

    mapEntityToEditor(entity: CompanyGroupResponse): Promise<EditorValues> {
        if (!entity.parent) {
            entity.parent = { id: 'root', name: this.admin.i18n.instant('SHARED.ROOT') };
        }
        return Promise.resolve(EntityUtils.mergeFields(this.properties, entity, {}));
    }

    mapEditorToEntity(entity: CompanyGroupUpdateRequest, values: EditorValues): Promise<CompanyGroupUpdateRequest> {
        const result = EntityUtils.mergeFields<CompanyGroupUpdateRequest>(this.properties, values, entity);
        if (result.parent && result.parent.id === 'root') {
            result.parent = null;
        }
        return Promise.resolve(result);
    }

    getFields(entity: CompanyGroupResponse): Promise<FormBuilderField[]> {

        return this.admin.getCached(`listCompanyGroups/${this.ownerId}`, api => api.accounts.listCompanyGroups(this.ownerId)).then(companyGroups => {

            const values = [
                { key: 'root', value: this.admin.i18n.instant('SHARED.ROOT') },
                ...EntityUtils.treeToComboValues(AssetGroupingService.toAssetGroupingItems(companyGroups.items), 1),
            ];

            return [
                ComboField('parent', this.translate('FIELDS.PARENT'), true, values, IdNameComboValueHandlers),
                TextField('name', this.translate('FIELDS.NAME'), true, 1, 255),
            ];
        }).then(fields => EntityUtils.prepareBulk(!entity, [], fields));
    }

}
